import * as React from "react";
// @ts-ignore
import classNames from "classnames";
import { withStyles } from "@material-ui/core";
import { StyleRulesCallback } from "@material-ui/core/styles";

function styled<P>(Component: React.ComponentType<P>, staticProps: any = {}) {
  return (styles: StyleRulesCallback<string>) => {
    const StyledComponent = (props: any) => {
      const { className, ...other } = props;
      return <Component className={className} {...staticProps} {...other} />;
    };

    const styledComponent: any = withStyles(styles)(StyledComponent);
    return styledComponent as React.ComponentType<P>;
  };
}

export default styled;



// WEBPACK FOOTER //
// ./src/components/Utils/styled.tsx